import { toast } from "react-toastify";
import { commonFileUpload, getAllNofificationForDashboard } from "src/thunks/dashboard";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import CancelIcon from '@mui/icons-material/Cancel';
import { yupResolver } from "@hookform/resolvers/yup";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Checkbox, InputLabel, TextField, Button, CircularProgress } from "@mui/material";
import { addDepotPersonalFormValidationSchema } from "src/helpers/yup_schema";
import { EditDepotPersonal, addNewDepotPersonal, getAllDepotPerson } from "src/thunks/depotUsers";
import toastMessages from "src/constant/toastMessages.json";
import { GetError } from 'src/constant';


export const AddDeportPersonalFrom = ({ setOpen, editData, setEditData, setEditTextFlag, editTextFlag, handleViewRecordButtonClick }) => {

      /** redux store useDispatch & useSelector ------------------------------ **/
      const dispatch = useDispatch();
      const { addNewDepotPersonelLoading } = useSelector((state) => state.depotUsers);

      /** hooks useState ----------------------------------------------------- **/
      const [isAdmin, setisAdmin] = useState(false);
      const [isLoading, setIsLoading] = useState(false);
      const [profilePic, setProfilePic] = useState("https://www.seekpng.com/png/detail/245-2454602_tanni-chand-default-user-image-png.png");

      /** react hook form declaration ------------------------------ **/
      const {
            register,
            handleSubmit,
            formState: { errors },
            reset
      } = useForm({
            resolver: yupResolver(addDepotPersonalFormValidationSchema),
      });

      /** hooks useEffect----------------------------------------------------- **/
      useEffect(() => {
            return () => {
                  setEditTextFlag(false);
            }
      }, [])

      useEffect(() => {
            setEditDataFun();
      }, [editData]);

      /** handler functions--------------------------------------------------- **/

      /** Function executes when a photo is uploaded and saved into the state. -------------------- **/
      const photoUpload = e => {
            setIsLoading(true);
            e.preventDefault();
            const reader = new FileReader();
            const file = e.target.files[0];
            if (file) {
                  const fileType = file.type;
                  if (!["image/png", "image/jpg", "image/jpeg", "image/jfif", "image/PNG", "image/JPG", "image/JPEG"].includes(fileType)) {
                        setIsLoading(false);
                        toast.error("Please select valid image format");
                  } else {
                        const formData = new FormData();
                        formData.append("files", file);
                        reader.onloadend = async () => {
                              let res = await dispatch(commonFileUpload(formData));
                              setIsLoading(false);
                              if (res) {
                                    const urlData = res.payload[0].url;
                                    setProfilePic(urlData);
                              }
                        };
                        reader.readAsDataURL(file);
                  }
            }

      };

      /** Function used to reset the data in the form, which is required for editing ------------------ **/
      const setEditDataFun = () => {
            if (Object.keys(editData).length > 0) {
                  reset({
                        firstName: editData?.firstName || "",
                        middleName: editData?.middleName || "",
                        lastName: editData?.lastName || "",
                        street: editData?.address?.street1,
                        town: editData?.address?.city,
                        country: editData?.address?.country,
                        postcode: editData?.address?.zip,
                        email: editData?.email,
                        phone: editData?.phoneNumber,
                  });
                  setProfilePic(editData?.profileUrl || '');
                  setisAdmin(editData?.roles.includes("Admin") ? true : false);
            }
      };

      /** function executes when clicking on 'Add New Depot User' or 'Edit Depot User' -------------------- **/
      const onAddDepotPersonalSubmitHandler = async (data) => {
            try {
                  let ModelData = {
                        "firstName": data?.firstName,
                        "lastName": data?.lastName,
                        "middleName": data?.middleName || "",
                        "role": isAdmin == true ? "Admin" : "DepotManager",
                        "email": data?.email,
                        "username": data?.email,
                        "address": {
                              "street1": data?.street || '',
                              "street2": '',
                              "country": data?.country,
                              "region": "",
                              "state": "",
                              "city": data?.town,
                              "zip": data?.postcode,
                              "locality": "",
                              "plotNumber": ""
                        },
                        "phoneNumber": (data?.phone).toString(),
                        "profileUrl": profilePic,
                        "projects": editTextFlag ? editData?.projects : []
                  };
                  if (Object.keys(editData).length > 0) {
                        ModelData = {
                              data: ModelData,
                              id: editData?.id,
                              "isParentResourceUpdated": true
                        };
                        await dispatch(EditDepotPersonal(ModelData)).unwrap();
                        await handleViewRecordButtonClick();
                        toast.success(toastMessages.depotUserEdited);
                        setEditData({});
                  } else {
                        await dispatch(addNewDepotPersonal(ModelData)).unwrap();
                        await dispatch(getAllDepotPerson()).unwrap();
                        toast.success(toastMessages.depotUserAdded);
                  }
                  setTimeout(() => {
                        dispatch(getAllNofificationForDashboard(1, 20));
                  }, 2000);
                  handleCancelButtonClick();
                  setProfilePic("");
            } catch (err) {
                  toast.error(GetError(err?.response?.data?.errors) || "something issue");
            }
      };

      /** Function executes when clicking on 'Cancel' ------------------ **/
      const handleCancelButtonClick = () => {
            setEditData({});
            setOpen(false);
            reset({});
            setProfilePic("https://www.seekpng.com/png/detail/245-2454602_tanni-chand-default-user-image-png.png");
      };

      return <div>
            <div className="depot-form-header-style">{editTextFlag ? "EDIT PERSONNEL" : "ADD PERSONNEL"}</div>
            <div style={{ marginTop: 10 }}>
                  <form className="add-depotpersonal-form-mainclass"
                        style={{ paddingLeft: 100, paddingRight: 100 }}
                        onSubmit={handleSubmit(onAddDepotPersonalSubmitHandler)}
                  >
                        <div className="d-flex flex-row justify-content-between align-items-center">
                              <div className="profileUpload">
                                    <img className="file-input-upload profile-img" src={profilePic} />
                                    <input className="file-input upload" type="file" accept='.png, .jpg, .jpeg, .PNG, .JPG, .JPEG' onChange={(e) => photoUpload(e)} />
                                    <span className="text-upload-photo">UPLOAD PHOTO</span>
                              </div>

                              <div className="loader-overlay" style={{ display: isLoading ? 'flex' : 'none' }}>
                                    <CircularProgress />
                              </div>

                              <div className="show-admin-checkbox d-flex flex-row align-items-center me-5">
                                    <Checkbox disabled={editTextFlag ? true : false} checked={isAdmin} onChange={({ target }) => setisAdmin(target.checked)} />
                                    <InputLabel>MAKE ADMIN</InputLabel >
                              </div>
                        </div>
                        <div className="row mt-2">
                              <div className="col-md-4">
                                    <TextField className="depot-form-textfields-style"   {...register("firstName")} id="standard-basic" label="FIRST NAME" variant="standard" />
                                    <div className="error-field-class">
                                          {errors.firstName?.message && errors.firstName?.message}
                                    </div>
                              </div>

                              <div className="col-md-4">
                                    <TextField className="depot-form-textfields-style"  {...register("middleName")} id="standard-basic" label="MIDDLE NAME(OPTIONAL)" variant="standard" />
                              </div>
                              <div className=" col-md-4">
                                    <TextField className="depot-form-textfields-style"  {...register("lastName")} id="standard-basic" label="LAST NAME" variant="standard" />
                                    <div className="error-field-class">
                                          {errors.lastName?.message && errors.lastName?.message}
                                    </div>
                              </div>
                        </div>
                        <span className="section-name-form-style">ADDRESS</span>
                        <div className="row m-0">
                              <TextField className="depot-form-textfields-style"  {...register("street")} id="standard-basic" label="STREET" variant="standard" />
                              <div className="error-field-class depotform-street-class">
                                    {errors.street?.message && errors.street?.message}
                              </div>
                        </div>
                        <div className="row">
                              <div className="col-md-4">
                                    <TextField className="depot-form-textfields-style"  {...register("town")} id="standard-basic" label="TOWN" variant="standard" />
                                    <div className="error-field-class">
                                          {errors.town?.message && errors.town?.message}
                                    </div>
                              </div>

                              <div className="col-md-4">
                                    <TextField className="depot-form-textfields-style"  {...register("country")} id="standard-basic" label="COUNTRY" variant="standard" />
                                    <div className="error-field-class">
                                          {errors.country?.message && errors.country?.message}
                                    </div>
                              </div>
                              <div className="col-md-4">
                                    <TextField className="depot-form-textfields-style"  {...register("postcode")} id="standard-basic" label="POSTCODE" variant="standard" />
                                    <div className="error-field-class">
                                          {errors.postcode?.message && errors.postcode?.message}
                                    </div>
                              </div>
                        </div>

                        <span className="section-name-form-style">CONTACT INFORMATION</span>
                        <div className="row mb-5">
                              <div className="col-md-4">
                                    <TextField className="depot-form-textfields-style" InputProps={{ readOnly: editTextFlag ? true : false }} {...register("email")} id="standard-basic" label="EMAIL" variant="standard" />
                                    <div className="error-field-class">
                                          {errors.email?.message && errors.email?.message}
                                    </div>
                              </div>

                              <div className="col-md-4">
                                    <TextField className="depot-form-textfields-style" type="string"
                                          {...register("phone")} id="standard-basic" label="PHONE" variant="standard" />
                                    <div className="error-field-class">
                                          {errors.phone?.message && errors.phone?.message}
                                    </div>
                              </div>
                              <div className="form-floating col-md-4">
                              </div>
                        </div>
                        <div
                              className="d-flex flex-row justify-content-between"
                              style={{ marginTop: 40, marginBottom: 20 }}
                        >
                              <Button variant="outlined" className="btn-bootstrap-submit-style" style={{ color: "red", borderColor: "red" }} startIcon={<CancelIcon />} onClick={() => handleCancelButtonClick()}>
                                    Cancel
                              </Button>
                              {editTextFlag ?
                                    <Button variant="outlined" className="btn-bootstrap-submit-style" startIcon={<CheckCircleIcon />} type="submit"
                                    >
                                          Save
                                    </Button> :

                                    <Button
                                          disabled={addNewDepotPersonelLoading ? true : false}
                                          variant="outlined"
                                          className={`btn-bootstrap-submit-style ${addNewDepotPersonelLoading ? "fade-out" : ""}`}
                                          startIcon={<CheckCircleIcon />}
                                          type="submit"
                                    >
                                          Submit
                                    </Button>}

                        </div>
                  </form>
            </div>
      </div>;
};